import { useCallback } from "react";

import { openRecapModal } from "~/meetings/MeetingModal/openRecapModal";

import type { CurrentTabType } from "../stream/MeetingContainer/MeetingContainerTabs";
import type { ChaptersPanelRef } from "./ChaptersPanel";

/**
 * @deprecated Do not use directly. This only exists to be able to use hook `useOnTimestampClick` in `NoteCard`.
 * (ENG-315) TODO: Return this logic back to `useOnTimestampClick` and delete this function once we can use hooks in
 * `NoteCard`, or once it's been refactored.
 */
export function onTimestampClickUtil(
	meetingRecordingsInSameMeeting: readonly string[],
	setSelectedRecordingId: (id: string) => void,
	videoRef: React.RefObject<HTMLVideoElement>,
	chaptersRef: React.RefObject<ChaptersPanelRef>,
	timestamp: number,
	recordingId?: string,
	setCurrentTab?: (tab: CurrentTabType) => void,
) {
	if (recordingId && !meetingRecordingsInSameMeeting.includes(recordingId)) {
		openRecapModal({ recordingId, timestamp });
		return;
	}

	if (setCurrentTab) {
		setCurrentTab("recap");
	}

	if (recordingId) {
		setSelectedRecordingId(recordingId);
	}

	const video = videoRef.current;
	if (!video) {
		chaptersRef.current?.handleTimeUpdate(timestamp + 0.1);
		return;
	}

	video.currentTime = Math.max(0, timestamp + 0.1);
}

export function useOnTimestampClick(
	meetingRecordingsInSameMeeting: readonly string[],
	setSelectedRecordingId: (id: string) => void,
	videoRef: React.RefObject<HTMLVideoElement>,
	chaptersRef: React.RefObject<ChaptersPanelRef>,
	setCurrentTab?: (tab: CurrentTabType) => void,
): (timestamp: number, recordingId?: string) => void {
	return useCallback(
		(timestamp: number, recordingId?: string) => {
			onTimestampClickUtil(
				meetingRecordingsInSameMeeting,
				setSelectedRecordingId,
				videoRef,
				chaptersRef,
				timestamp,
				recordingId,
				setCurrentTab,
			);
		},
		[meetingRecordingsInSameMeeting, setCurrentTab, setSelectedRecordingId, videoRef, chaptersRef],
	);
}
